<template>
  <div id="power">
    <div>
      <el-tabs @tab-click="handleClick" v-for="(time,index) in datahededata" :key="index">
        <el-tab-pane :label="time.Name"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="power">
      <div class="left">
        <el-menu
          default-active="1"
          class="el-menu-vertical-demo"
          v-for="(k,index) in datahededata"
          :key="index"
        >
          <el-menu-item
            @click="clickleft(o.Model)"
            :index="o.Index.toString()"
            v-for="(o,index) in k.List"
            :key="index"
          >
            <span slot="title">{{o.Model}}</span>
          </el-menu-item>
        </el-menu>
      </div>
      <div class="box_right">
        <!-- <div>说的</div> -->
        <div class="right" v-if="IfShow">
          <img
            src="../../../assets/timg.gif"
            style="display: block;height: 402px; margin: 0 auto;"
            alt
          />
        </div>
        <div class="right" v-if="!IfShow">
          <div class="right_box">
            <template v-for="(time,index) in tableData">
              <el-table-column :key="index">
                <label class="label">{{time.Name}}</label>
                <el-checkbox
                  class="labels"
                  v-model="time.ifShow"
                  @change="SeeChanges(time.List,index,time.ifShow,time)"
                ></el-checkbox>
                <el-checkbox
                  class="label"
                  v-for="(times,index) in time.List"
                  :key="index"
                  v-model="times.Status"
                  @change="StatusChanges(times.Status,times.Id,times,time)"
                >{{times.Action}}</el-checkbox>
              </el-table-column>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tool from "@/utils/tool";
export default {
  components: {
    // powers
  },
  data() {
    return {
      IfShow: true,
      changename: "0",
      fit: false,
      loading: true,
      leftdatalist: this.leftdata,
      // data: this.tableData,
      tableData: [],
      Header: this.ObtainHeader,
      asdf: false,
      asdfghfd: false,
      activeName: "first",
      datahededata: [],
      index1: false,
      index: 0,
      Models: "",
      checked: true,
      datacheckbox: {
        one: false,
        two: false,
        Three: false,
        Four: false,
        Five: false,
        Six: false,
        Seven: false,
        Eight: false,
        Nine: false,
        Ten: false,
        Eleven: false
      },
      dist: 0,
      eventdata: [],
      shutopen: "", //关
      open: "" //开
    };
  },
  props: {
    leftdata: Array,
    ObtainHeader: Array,
    datahede: Array
  },
  methods: {
    ButtonPower() {
      tool.removeLocal("Button_Power");
      let jparams = {
        user_id: tool.getLocal("userid"), //用户id
        session_id: tool.getLocal("sessionid") //用户凭证
      };
      this.request
        .post("/index/Privileges/get_user_group_priv", {
          jparams: JSON.stringify(jparams)
        })
        .then(res => {
          let { status, data } = res;
          if (status == 0) {
            tool.saveLocal("Button_Power", data);
          }
        });
    },
    // SeeChange(val, index, Statu) {
    //   this.tableData[index].List[1].Status;
    //   if (Statu == true) {
    //     this.tableData[index].List[1].Status = true;
    //   }
    //   let jparams = {
    //     user_id: tool.getLocal("userid"), //用户id
    //     session_id: tool.getLocal("sessionid"), //用户凭证
    //     data: [
    //       {
    //         Id: val.Id,
    //         Status: val.Status
    //       }
    //     ]
    //   };
    //   this.request
    //     .post("/index/Privileges/update_group_priv", {
    //       jparams: JSON.stringify(jparams)
    //     })
    //     .then(res => {
    //       let { status, description } = res;
    //       if (status == 0) {
    //         this.$message({
    //           message: description,
    //           type: "success",
    //           duration: 300
    //         });
    //         this.ButtonPower();
    //       }
    //     });
    // },
    StatusChanges(val, index, times, time) {
      let data = [];
      if (times.Action == "查看") {
        if (val) {
          data.push({ Id: index, Status: val });
        } else {
          time.List.map(tiem => {
            tiem.Status = false;
            data.push({ Id: tiem.Id, Status: false });
          });
        }
      } else {
        if (val) {
          time.List[0].Status = true;
          data.push(
            { Id: time.List[0].Id, Status: true },
            { Id: index, Status: val }
          );
        } else {
          data.push({ Id: index, Status: val });
        }
      }
      if (!val) {
        if (time.List.every(items => items.Status === false)) {
          time.ifShow = false;
        }
      } else {
        if (time.List.every(items => items.Status === true)) {
          time.ifShow = true;
        }
      }
      let jparams = {
        user_id: tool.getLocal("userid"), //用户id
        session_id: tool.getLocal("sessionid"), //用户凭证
        data: data
      };
      this.request
        .post("/index/Privileges/update_group_priv", {
          jparams: JSON.stringify(jparams)
        })
        .then(res => {
          // console.log(res);

          let { status, description } = res;
          if (status == 0) {
            this.$message({
              message: description,
              type: "success",
              duration: 300
            });
            this.ButtonPower();
          }
        });
    },
    SeeChanges(status, index, ifshow, time) {
      for (let i = 0; i < status.length; i++) {
        const element = status[i];
        if (ifshow) {
          element.Status = true;
        } else {
          element.Status = false;
        }
      }
      let jparams = {
        user_id: tool.getLocal("userid"), //用户id
        session_id: tool.getLocal("sessionid"), //用户凭证
        data: status
      };
      this.request
        .post("/index/Privileges/update_group_priv", {
          jparams: JSON.stringify(jparams)
        })
        .then(res => {
          let { status, description } = res;
          if (status == 0) {
            this.$message({
              message: description,
              type: "success",
              duration: 300
            });
            this.ButtonPower();
          }
        });
    },
    clickleft(name) {
      this.loading = true;
      let jparams = {
        user_id: tool.getLocal("userid"), //用户id
        session_id: tool.getLocal("sessionid"), //用户凭证
        GroupId: this.dist,
        Model: name
      };
      this.request
        .post("/index/Privileges/get_group_priv", {
          jparams: JSON.stringify(jparams)
        })
        .then(res => {
          // console.log(res);
          let { status, description, data } = res;
          if (status == 0) {
            this.tableData = data;
            this.loading = false;
          }
        });
    },
    handleClick(tab, event) {},
    // 页首
    Discontinuation() {
      let jparams = {
        user_id: tool.getLocal("userid"), //用户id
        session_id: tool.getLocal("sessionid"), //用户凭证
        GroupId: this.dist
      };
      this.request
        .post("/index/Privileges/get_group_struct", {
          jparams: JSON.stringify(jparams)
        })
        .then(res => {
          let { data, status } = res;
          this.Models = data[0].List[0].Model;
          if (status == 0) {
            this.datahededata = data;
            this.tabledatas();
            this.IfShow = false;
          }
        });
    },
    tabledatas() {
      this.loading = true;
      let jparams = {
        user_id: tool.getLocal("userid"), //用户id
        session_id: tool.getLocal("sessionid"), //用户凭证
        GroupId: this.dist,
        Model: this.Models
      };
      this.request
        .post("/index/Privileges/get_group_priv", {
          jparams: JSON.stringify(jparams)
        })
        .then(res => {
          this.tableData = res.data;
          res.data.map(item => {
            if (item.List.every(items => items.Status === true)) {
              item.ifShow = true;
            }
          });
        });
    }
  },
  mounted() {
    this.dist = this.$tab.query().dist;
    this.Discontinuation();
  },
  created() {},
  watch: {
    tableData: {
      handler(newValue, oldValue) {
        for (let index = 0; index < newValue.length; index++) {
          const element = newValue[index];
          for (let i = 0; i < element.List.length; i++) {
            const element2 = element.List[i];
          }
        }
        this.tableData.map(item => {
          if (item.List.every(items => items.Status === false)) {
            item.ifShow = false;
          }
          if (item.List.every(items => items.Status === true)) {
            item.ifShow = true;
          }
        });
      }
    },
    asdf: {
      handler(newValue, oldValue) {
        if (newValue == true) {
          this.asdfghfd = true;
        } else {
          this.asdfghfd = false;
        }
      }
    }
  }
};
</script>

<style lang="less">
.el-menu-item.is-active {
  color: #fff;
  background-color: #409eff;
}
.el-menu {
  border: none;
}

@import "./power.less";
</style>


// WEBPACK FOOTER //
// src/components/Dialog/power/power.vue